import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, AlertTriangle, Loader2 } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailVerifyPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!token) { setStatus('missing'); return; }
    axios
      .get(`${API}/auth/email/verify`, { params: { token } })
      .then((r) => { setEmail(r.data.email || ''); setStatus('ok'); })
      .catch(() => setStatus('failed'));
  }, [token]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12" data-testid="email-verify-page">
      <SEO title="Verify Email" noIndex />
      <Card className="max-w-md w-full text-center">
        <CardContent className="p-8 space-y-4">
          {status === 'loading' && <Loader2 className="h-8 w-8 animate-spin mx-auto text-muted-foreground" />}
          {status === 'ok' && (
            <>
              <CheckCircle className="h-12 w-12 mx-auto text-green-600" />
              <h1 className="text-2xl font-heading font-light">Email verified</h1>
              <p className="text-sm text-muted-foreground">{email ? <>You're all set, <strong>{email}</strong>.</> : 'You\'re all set.'} You can now place orders.</p>
              <Button asChild className="bg-[hsl(210,45%,40%)] hover:bg-[hsl(210,45%,30%)] text-white"><Link to="/dashboard">Go to Dashboard</Link></Button>
            </>
          )}
          {(status === 'failed' || status === 'missing') && (
            <>
              <AlertTriangle className="h-12 w-12 mx-auto text-amber-500" />
              <h1 className="text-2xl font-heading font-light">Verification link invalid</h1>
              <p className="text-sm text-muted-foreground">This link may have expired or already been used. Sign in and request a fresh verification email from your dashboard.</p>
              <Button asChild variant="outline"><Link to="/login">Go to Sign In</Link></Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
